import { render, staticRenderFns } from "./ProjectsAdd.vue?vue&type=template&id=e85065ba&scoped=true"
import script from "./ProjectsAdd.vue?vue&type=script&lang=js"
export * from "./ProjectsAdd.vue?vue&type=script&lang=js"
import style0 from "./ProjectsAdd.vue?vue&type=style&index=0&id=e85065ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e85065ba",
  null
  
)

export default component.exports